// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1a4RA","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3C7Ci"};